import { Pipe, PipeTransform } from '@angular/core';
import { Standing } from '../standing';
import { StandingsConfig } from './standings-config';

@Pipe({
  name: 'standingsFilter'
})
export class StandingsFilterPipe implements PipeTransform {
  transform(standings: Standing[], standingsConfig: StandingsConfig): Standing[] {
    return standings.filter(standing =>
      (
        standingsConfig.category === undefined
        || (
          Array.isArray(standingsConfig.category)
            ? standingsConfig.category.find(category => category == standing.driver.category)
            : standing.driver.category === standingsConfig.category
        )
      )
    );
  }
}
